import CRUDService from "./base/CRUDService";

class InventoryService extends CRUDService {

  constructor() {
    super()
  }

  base_url = 'inventory/v1/inventories/'
  base_execution_url = 'inventory/v1/inventories-executions/'

  getBaseURL() {
    return this.base_url
  }

  getExecutionURL() {
    return this.base_execution_url
  }
  getSummaryByInventoryId(inventoryId, params) {
    return this.getHttpRequest().get(`${this.getBaseURL()}${inventoryId}/items/by-products-types?${params}`)
  }
  getInventoryDetails(inventoryId) {
    return this.getHttpRequest().get(`${this.getExecutionURL()}inventories/${inventoryId}`)
  }

  createInventory(inventory) {
    return this.getHttpRequest().post(this.getBaseURL(), inventory)
  }

  markInventoryAsExecuting(inventory) {
    return this.getHttpRequest().put(`${this.getBaseURL()}${inventory.id}/executing`);
  }

  finishInventory(inventoryId, finishInventory) {
    return this.getHttpRequest().post(`${this.getBaseURL()}${inventoryId}/finish`, finishInventory)
  }

  getInventorySummary(inventoryId) {
    return this.getHttpRequest().get(`${this.getBaseURL()}${inventoryId}/summary`)
  }
}

export default InventoryService



// WEBPACK FOOTER //
// ./src/services/InventoryService.js